import Shimmer from "components/ui/shimmer"

const WizardLoading = () => (
  <>
    {/* Wizard Options*/}
    {[...Array(3)].map((opt, i) => (
      <div className="border-b-grey-10 border-b bg-white p-10" key={`load${i}`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Shimmer
              className="mr-15 rounded-full"
              style={{ height: "40px", width: "40px" }}
            />
            <div>
              <Shimmer
                className="mb-5"
                style={{ height: "10px", width: "100px" }}
              />
              <Shimmer style={{ height: "10px", width: "160px" }} />
            </div>
          </div>
          <Shimmer style={{ height: "14px", width: "60px" }} />
        </div>
      </div>
    ))}
  </>
)

export default WizardLoading
